"use client";

import Image from "next/image";
import Link from "next/link";

import FaIcon from "../FaIcon";
import FooterLink from "./FooterLink";

import logo from "./images/logo.svg";
import twitter from "./images/twitter-logo.png";
import iso from "./images/ISO27001certified.svg";
const styles = new Proxy({"Footer":"Footer-58a47","FooterLogo":"FooterLogo-58a47","Info":"Info-58a47","Offices":"Offices-58a47","Twitter":"Twitter-58a47","MenuWrapper":"MenuWrapper-58a47","MenuItem":"MenuItem-58a47"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const currentYear = new Date().getFullYear();

const Footer = () => (
  <footer>
    <div className={styles.Footer}>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-5 p-4 p-lg-0">
            <div className="mb-4">
              <Image
                src={logo}
                className={styles.FooterLogo}
                alt="Cursor Insight"
                sizes="(max-width: 768px) 80vw, 400px"
                width={400}
                height={72}
              />
            </div>
            <div className={styles.Info}>
              <span>&copy; {currentYear}, Cursor Insight Ltd</span> |
              <FooterLink to="/document/cookie-policy">
                Cookie Policy
              </FooterLink>
              |
              <FooterLink to="/document/privacy-policy">
                Privacy Policy
              </FooterLink>
            </div>
            <div className="mb-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/cursorinsight"
                className={`mx-1 mx-lg-0 me-lg-2 ${styles.Twitter}`}
              >
                <Image
                  src={twitter}
                  alt="Twitter"
                  sizes="24px"
                  width={14.8}
                  height={14.48}
                />
              </a>

              <FaIcon
                id="fa-linkedin"
                href="https://www.linkedin.com/company/cursor-insight"
              />

              <FaIcon
                id="fa-facebook"
                href="https://www.facebook.com/cursorinsight"
              />

              <FaIcon id="fa-github" href="https://github.com/cursorinsight" />

              <FaIcon
                id="fa-youtube"
                href="https://www.youtube.com/@cursorinsight7572"
              />
            </div>
            <div className={styles.Offices}>
              <span>London | United Kingdom</span>
              <span>Budapest | Hungary</span>
              <Image
                src={iso}
                className="mt-4"
                alt="ISO 27001"
                sizes="200px"
                width={72}
                height={33}
              />
            </div>
          </div>

          <div className="col-lg-7">
            <div className={styles.MenuWrapper}>
              <div className={styles.MenuItem}>
                <h3>
                  <Link href="/solutions">Solutions</Link>
                </h3>
                <ul>
                  <li>
                    <span>Cybersecurity</span>
                    <a
                      href="https://graboxy.com/solutions/continuous-authentication"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Continuous Authentication
                    </a>
                    <a
                      href="https://graboxy.com/solutions/multi-factor-authentication"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Silent 2FA
                    </a>
                    <a
                      href="https://graboxy.com/solutions/device-fingerprinting"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Device Fingerprinting
                    </a>
                    <a
                      href="https://graboxy.com/solutions/remote-desktop-detection"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Remote Desktop Detection
                    </a>
                    <a
                      href="https://graboxy.com/solutions/captcha-bot-detection"
                      rel="noreferrer"
                      target="_blank"
                    >
                      CAPTCHA & Bot Detection
                    </a>
                  </li>
                  <li>
                    <span>e-Health</span>
                    <a
                      href="/MotionAnalysisHealth"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Clinical Diagnostics
                    </a>
                    <a
                      href="/updrs-assessment-demo"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Parkinson&apos;s Assessment
                    </a>
                  </li>
                  <li>
                    <span>Biometrics</span>
                    <a
                      href="https://signowise.com"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Biometrics e-Signatures
                    </a>
                    <a
                      href="https://www.motionscore.ai"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Credit Scoring & Default Prediction
                    </a>
                    <a
                      href="/walking-recognition"
                      rel="noreferrer"
                      target="_blank"
                    >
                      CCTV Gait Recognition
                    </a>
                    <a
                      href="/sensor-and-video-analysis"
                      rel="noreferrer"
                      target="_blank"
                    >
                      3D Movement Analysis
                    </a>
                  </li>
                </ul>
              </div>
              <div className={styles.MenuItem}>
                <h3>
                  <Link href="/">Use Cases</Link>
                </h3>
                <ul>
                  <li>
                    <Link href="/banking-solutions">Banking</Link>
                    <Link href="/healthcare">Healthcare</Link>
                    <Link href="/government">Government</Link>
                    <Link href="/law-enforcement">Law Enforcement</Link>
                    <Link href="/cybersecurity">Cybersecurity</Link>
                    <Link href="/gaming">Gaming</Link>
                  </li>
                </ul>
                <h3>
                  <Link href="/">Resources</Link>
                </h3>
                <ul>
                  <li>
                    <Link href="/resources#use-cases">Case Studies</Link>
                    <Link href="/resources#blog">Blog</Link>
                    <Link href="/resources#whitepapers">Whitepaper</Link>
                    <Link href="/resources#scientific-papers">
                      Scientific Papers
                    </Link>
                    <Link href="/resources#posters">Posters</Link>
                  </li>
                </ul>
              </div>

              <div className={styles.MenuItem}>
                <h3>
                  <Link href="/">Technology</Link>
                </h3>
                <ul>
                  <li>
                    <Link href="/technology">What’s under the hood</Link>
                  </li>
                </ul>
                <h3>
                  <Link href="/">Contact</Link>
                </h3>
                <ul>
                  <li>
                    <a href="mailto:info@cursorinsight.com">
                      Contact Cursor Insight
                    </a>
                    <a href="mailto:support@cursorinsight.com">
                      Contact Support
                    </a>
                    <a href="mailto:investing@cursorinsight.com">
                      For Investors
                    </a>
                    <a href="mailto:marketing@cursorinsight.com">Marketing</a>
                    <a
                      href="https://calendly.com/tamas-cursor-insight/consultation"
                      target="_blank"
                    >
                      Request Pricing
                    </a>
                    <a
                      href="https://calendly.com/tamas-cursor-insight/consultation"
                      target="_blank"
                    >
                      Request Demo
                    </a>
                  </li>
                </ul>
                <h3>
                  <Link href="/">Company</Link>
                </h3>
                <ul>
                  <li>
                    <Link href="/our-team">Our Team</Link>
                    <Link href="/our-team">Founders</Link>
                    <Link href="/our-team">Career</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
